<template>
  <router-link
    class="portal-content-card text-decoration-none"
    :to="{ name: 'content-home', params: { contentProductId } }"
  >
    <div class="content-card-wrapper">
      <div class="content-card" :style="style">
        <img
          v-if="showPlaceholder"
          class="img-partner-placeholder"
          :src="$setup.partnerLogo"
        />
      </div>
    </div>
    <h5 class="content-name text-wrap pt-2 mb-0">{{ content.name }}</h5>
    <small v-if="modulesLabel" class="content-modules">{{
      modulesLabel
    }}</small>
  </router-link>
</template>

<script>
import get from "lodash/get";

export default {
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    contentProductId() {
      return String(this.content.product_id);
    },
    cover() {
      return (
        get(this.content, "cover") ||
        get(this.content, "background") ||
        get(this.content, "logo") ||
        ""
      );
    },
    showPlaceholder() {
      return !this.cover;
    },
    style() {
      if (!this.cover) return "";

      const gradient = "linear-gradient(0deg, #0c0d1395 0%, #0c0d1300 80%)";
      return `background-image: ${gradient}, url(${this.cover});`;
    },
    modulesLabel() {
      const total = get(this.content, "number_of_modules", 0);
      if (!total) return "";

      return total === 1 ? "1 módulo" : `${total} módulos`;
    }
  }
};
</script>

<style lang="scss" scoped>
.portal-content-card {
  display: block;

  .content-card-wrapper {
    padding: 0;
    border-radius: 6px;
    transition: border 0.1s ease-in-out, padding 0.1s ease-in-out;

    .content-card {
      aspect-ratio: 200/290;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      height: 100%;
      width: 100%;
      border-radius: 6px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .img-partner-placeholder {
        max-height: 48px;
        max-width: 48px;
        min-height: 48px;
        min-width: 48px;
      }
    }

    &:hover {
      border: 2px solid #3e56ac !important;
      padding: 2.5px;

      .content-card {
        border-radius: 4px;
      }
    }
  }

  .content-name {
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;

    @media screen and (max-width: 768px) {
      font-size: 12px !important;
    }
  }

  .content-modules {
    opacity: 0.6;
    font-size: 12px;
    font-weight: 600;
  }
}
</style>
